import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloLink, split } from 'apollo-link'
import { WebSocketLink } from 'apollo-link-ws'
import { createUploadLink } from 'apollo-upload-client'
import { getMainDefinition } from 'apollo-utilities'

const graphqlEndpoint = process.env.REACT_APP_GRAPHQL_ENDPOINT
const graphqlWsEndpoint = process.env.REACT_APP_GRAPHQL_WS_ENDPOINT

const wsLink = new WebSocketLink({
  uri: graphqlWsEndpoint,
  options: {
    reconnect: true
  }
})

const uploadLink = createUploadLink({
  uri: graphqlEndpoint
})

const middlewareAuthLink = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem('user-token')
  const authorizationHeader = token ? `Bearer ${token}` : null
  operation.setContext({
    headers: {
      authorization: authorizationHeader
    }
  })
  return forward(operation)
})

const httpLinkWithAuthToken = middlewareAuthLink.concat(uploadLink)

const link = split(
  ({ query }) => {
    const { kind, operation } = getMainDefinition(query)
    return kind === 'OperationDefinition' && operation === 'subscription'
  },
  wsLink,
  httpLinkWithAuthToken
)

const client = new ApolloClient({
  link,
  cache: new InMemoryCache()
})

export default client



// WEBPACK FOOTER //
// ./src/graphql/index.js